import type React from 'react';
import type { CSSProperties } from 'react';

import Style from './Legend.module.css';

export interface ILegendItem {
    title: string;
    color: string;
}

interface ILegend {
    items: ILegendItem[];
    isColumn?: boolean;
    className?: string;
}

const columnStyle: CSSProperties = { flexDirection: 'column' };
const itemStyle = { marginRight: 16 };

export const Legend: React.FC<ILegend> = (props) => {
    const { items, isColumn, className } = props;

    return (
        <div className={`${Style.legend} ${className}`} style={isColumn ? columnStyle : undefined}>
            {items.map((item) => (
                <div className={Style.legendItem} key={item.title} style={!isColumn ? itemStyle : undefined}>
                    <div className={Style.legendMark} style={{ background: item.color }} />
                    <div className={Style.legendTitle}>{item.title}</div>
                </div>
            ))}
        </div>
    );
};

Legend.displayName = 'Legend';
